export default {
  'loanAccountDetails.title': 'Loan Account Details',
  'loanAccountDetails.accountSelection': 'General Loan Account',
  'loanAccountDetails.gridName': 'LoanAccountDetails',
  'loanAccountDetails.transactionsFor': 'Transactions for',

  // Column Names
  // rest of the other columns will get labels from common file
  'loanAccountDetails.transactionDescription': 'Transaction Description',
  'loanAccountDetails.bankRefCode': 'Bank Reference Code',

  // TEMPORARY: making spaces between, as it's breaking a grid layout on mobile
  'loanAccountDetails.debit': 'Debit / Draw',
  'loanAccountDetails.credit': 'Credit / Payment',

  'loanAccountDetails.effectiveDate': 'Effective Date',

  // For Dropdown:
  'loanAccountDetails.balancesAsOf': 'Balances as of'
};
